import { OPENABLE_EXTENSION_TO_MIME } from '@app/constants/file-uploads';
import { CODE_TYPE_ITEMS_ALL } from '@app/domain/qr-code/constants';

export const BULK_TYPE_ITEMS = [CODE_TYPE_ITEMS_ALL[0], CODE_TYPE_ITEMS_ALL[4]];

export const ACCEPT = OPENABLE_EXTENSION_TO_MIME.csv;
export const MAX_FILE_SIZE_MB = 15 * 1024 * 1024;
